import { render, staticRenderFns } from "./partnershipEdit.vue?vue&type=template&id=203cd5a1"
import script from "./partnershipEdit.vue?vue&type=script&lang=ts"
export * from "./partnershipEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports